import React from 'react'
import Button from '../../atoms/Button/Button'
import { Alert } from '../../atoms/NewIcons'
import Link from 'next/link'

const ErrorFileUploadCard = () => {
  return (
    <>
      <div className="uploadError__container__fixed">
        <div className="uploadError">
          <div className="uploadError__content">
            <div className="uploadError__content__header">
              <Alert className="uploadError__content__header__icon" />
              <p className="uploadError__content__header__title">
                Problema di lettura con il file caricato
              </p>
              <p>
                Non è stato possibile caricare il file inserito, ti preghiamo di verificare se gli
                articoli sono stati corretamente inseriti
              </p>
              <div className="uploadError__content__header__link">
                <Link legacyBehavior href="">
                  <a href="" target="_blank">
                    <Button label="Guarda il file campione" />
                  </a>
                </Link>
              </div>
            </div>
            <div className="uploadError__content__actions">
              <Button
                label={'Anulla'}
                variant="secondary"
                size="large"
                bg="white"
                color="rgb(48,70,89)"
              />
              <Button
                label={'Carica un altro file'}
                variant="primary"
                size="large"
                color="white"
                bg="rgb(48,70,89)"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ErrorFileUploadCard
